import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef,  } from 'react';
import {ajax, unparam, chatColor} from 'utils/common';
import VideoPlayer from "components/videoPlayer";
import InterviewQues from '../common/interviewQues';
import VideoPage from "../common/video";

import qnNumBg from '../../../images/aiReport/qn-num-bg.png';
import userReport from "../../../images/aiReport/user-report.png";

const ResultApp = forwardRef((props, ref) => {
    const {
        themeColor = '#636DFF',
        muted,
        offsetDur,
        noOption,
        changeVideo,
        playEnd,
        handleTimeUpdate,
        closeAudio,
        data = {},
        userInfo = {},
    } = props;
    const videoPlayer = useRef(null);
    const queryString = unparam(location.search);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [autoPlay, setAutoPlay] = useState(false);
    const [videoUrl, setVideoUrl] = useState('');
    const [videoDec, setVideoDec] = useState('');
    const [interviewQuesVOs, setInterviewQuesVOs] = useState(null);
    const [paperInfo, setPaperInfo] = useState({});
    // 新版 true
    const isVersion = true;

    useImperativeHandle(ref, () => (
        {
            closeVideo: ()=> {
                // videoPlayer.current.pause()
                let videos = document.getElementsByTagName('video');
                pauseAll(1000,videos);
            }
        }
    ), []);

    useEffect(() => {
        getPaper(queryString.accountId, true);
    },[]);

    const getPaper = (accountId, showVideo) => {
        ajax({
            url: "/rept/paper/getPaperById",
            data: {
                ...queryString,
                accountId: accountId
            }
        }).then(res => {
            //试卷列表
            let interviewQuesVOs = res.data.interviewQuesVOs || [];
            setPaperInfo(res.data || {});
            //获取第一个视频的url
            if(showVideo){
                if(isVersion){
                    // videoURL
                    interviewQuesVOs.forEach(v => {
                        // v.itemVideoUrl = `/oivi/api/file/review/${v.videoURL}`;
                        v.isPlaying = false;
                    })
                    setInterviewQuesVOs(interviewQuesVOs);
                }else{
                    setInterviewQuesVOs(interviewQuesVOs);
                    changeClick(interviewQuesVOs[0].questionId, res.data.paperId);
                }
            }
        })
    }

    // 触发播放
    const playNoVideo = (index) => {
        closeAudio && closeAudio();
        // 播放当前
        if(!interviewQuesVOs[index].itemVideoUrl && interviewQuesVOs[index].videoURL){
            interviewQuesVOs[index].itemVideoUrl = `/oivi/api/file/review/${interviewQuesVOs[index].videoURL}`;
            setInterviewQuesVOs([...interviewQuesVOs]);
        }
    };

    const handleClick = (qId, index, autoPlay) => {
        //设置选中题号
        setSelectedIndex(index);
        setAutoPlay(autoPlay || false);
        changeClick(qId);
        closeAudio();
    }

    const changeClick = (qId, paperId) => {
        //获取视频的url
        ajax({
            url: "/api/file/viewVideo",
            data: {
                accountId: queryString.accountId,
                paperId: paperId || paperInfo.paperId,
                questionId: qId
            }
        }).then(res => {
            setVideoUrl("/oivi/api/file/review/"+ res.data.videoFileUrl);
            setVideoDec(res.data && res.data.text || '');
        })
    }

    // 触发监听播放某个video 暂停其他video播放
    useEffect(() => {
        let videos = document.getElementsByTagName('video');
        // controlPlay(videos);
    }, [interviewQuesVOs]);

    const controlPlay = (videos) => {
        for (let i = videos.length - 1; i >= 0; i--) {
            (function(){
                let p = i;
                videos[p].addEventListener('play',function(){
                    console.log(p,"====ewew")
                    pauseAll(p, videos);
                })
            })()
        }
    };

    const pauseAll = (index, videos) => {
        for (let j = videos.length - 1; j >= 0; j--) {
            if (j!=index) {
                videos[j].pause();
            }
        }
    };

    const oldResult = () => {
        return (
            <div className="analysis-queVideo">
                <InterviewQues handleClick={handleClick} selectedIndex={selectedIndex}
                               interviewQuesVOs={interviewQuesVOs || []} />
                <div className="analysis-que-wrap-cont">
                    <div className={`otherVideo`}>
                        <VideoPlayer
                            ref={videoPlayer}
                            muted={muted}
                            offsetDur={offsetDur}
                            noOption={noOption}
                            changeVideo={changeVideo}
                            handleEnded={playEnd}
                            autoPlay={autoPlay}
                            handleTimeUpdate={handleTimeUpdate}
                            handlePlay={closeAudio}
                            videoUrl={videoUrl}
                            themeColor={themeColor} />
                    </div>
                    <div className="analysis-que-cont">
                        <div className="analysis-que-q">
                            <img src={qnNumBg}/>
                            <span>Q{selectedIndex + 1}</span>
                        </div>
                        {interviewQuesVOs && interviewQuesVOs[selectedIndex] && <div className="analysis-que-title">{interviewQuesVOs[selectedIndex].cnName}</div>}
                        {videoDec && <div className="analysis-que-content">{videoDec}</div>}
                    </div>
                </div>
            </div>
        )
    };

    const newResult = () => {
        if(interviewQuesVOs) {
            return (
                <div className="analysis-queVideo new-analysis-queVideo">
                    {
                        interviewQuesVOs.map((item, key) => {
                            // abilityItem 存在就是有量度题 不做显示
                            if(item.abilityItem && item.questType === 'single_choice') return null;
                            return (
                                <div key={`video_item_${key}`} className="ques-item">
                                    <div className="ques-item-topic">
                                        <div className="ques-item-num"><i></i><span>{key + 1}.</span></div>
                                        <p>{item.cnName || ''}{item.abilityItem && <label>{item.abilityItem}</label>}{(item.questType === 'single_choice' && !item.choice) && <i>（候选人未作答）</i>}</p>
                                    </div>
                                    {item.questType === 'single_choice' ?
                                        <div className="ques-item-select">
                                            {
                                                item.options && item.options.map((value, k) => {
                                                    return <p key={`val_${k}_${key}`} className={`${item.choice == value.id ? 'active' : ''}`}>
                                                        {value.content || ''}
                                                        {item.choice == value.id && <i>（候选人的答案）</i>}
                                                    </p>
                                                })
                                            }
                                        </div>
                                        :
                                        <div className="analysis-que-wrap-cont">
                                            <div className={`otherVideo`}>
                                                <VideoPage
                                                    isPlaybackRate={true}
                                                    poster={data.facePicPath || userInfo.facePicPath || userReport}
                                                    changeVideo={()=>{
                                                        closeAudio && closeAudio();
                                                    }}
                                                    videoUrl={item.itemVideoUrl}
                                                    playNoVideo={() => playNoVideo(key)}
                                                />
                                            </div>
                                            <div className="analysis-que-cont">
                                                {item.text && <div className="analysis-que-content">{item.text}</div>}
                                            </div>
                                        </div>
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            )
        } else {
            return null;
        }
    };

    return (
        <div className="interview-record-wrap">
            <div className="readingTitleWrap">
                <div className="readingTitleLeft">
                    <div className="readingTitleLeftIcon">
                        <span></span>
                        <span></span>
                    </div>
                    <span>面试记录</span>
                </div>
            </div>
            {/*内容部分*/}
            <div className="result-padding">
                {isVersion ? newResult() : oldResult()}
            </div>

        </div>
    );
})

export default ResultApp;
